export const PALETTE = {
  bg:         "#F8F6F2",
  surface:    "#F0EDE6",
  surfaceAlt: "#E8E4DC",
  border:     "rgba(28,24,20,0.08)",
  primary:    "#9E8456",
  primaryMid: "rgba(158,132,86,0.65)",
  primarySoft:"rgba(158,132,86,0.10)",
  text:       "#1C1814",
  textMid:    "rgba(28,24,20,0.62)",
  textMute:   "rgba(28,24,20,0.38)",
  textFaint:  "rgba(28,24,20,0.20)",
  dark:       "#1C1814",
  danger:     "#C0392B",
};
